import { PerspectiveCamera as ThreePerspectiveCamera } from "three";
/**
 * Implements the IPerspectiveCamera interface for ThreeJS
 */
export class PerspectiveCamera extends ThreePerspectiveCamera {
    getProjectionMatrix(proj) {
        if (typeof proj !== "undefined") {
            proj.elements.length = 16;
            for (let i = 0; i < proj.elements.length; i += 1) {
                proj.elements[i] = this.projectionMatrix.elements[i];
            }
            return proj;
        }
        else {
            return this.projectionMatrix.clone();
        }
    }
    getInverseProjectionMatrix(proj) {
        if (typeof proj !== "undefined") {
            proj.elements.length = 16;
            for (let i = 0; i < proj.elements.length; i += 1) {
                proj.elements[i] = this.projectionMatrixInverse.elements[i];
            }
            return proj;
        }
        else {
            return this.projectionMatrixInverse.clone();
        }
    }
    setFieldOfView(fov) {
        this.fov = fov;
        this.updateProjectionMatrix();
    }
    getFieldOfView() {
        return this.fov;
    }
    setAspectRatio(ratio) {
        this.aspect = ratio;
        this.updateProjectionMatrix();
    }
}
